module.exports = __webpack_public_path__ + "files/d4ddeb79f4bb96900527f38ab04939e7.png";